export function setupOverflowGradient({ gradientSelector, containerSelector, scrollableSelector, root }) {
    const gradientDiv = root?.querySelector(gradientSelector);
    const container = root?.querySelector(containerSelector);
    const scrollable = container?.querySelector(scrollableSelector);

    if (!gradientDiv || !scrollable) return;


    const updateGradient = () => {
        const maxScrollLeft = scrollable.scrollWidth - scrollable.clientWidth;
        const scrollLeft = scrollable.scrollLeft;

        if (scrollLeft === 0) {
            container.removeAttribute('style');
            gradientDiv.style.opacity = '1';
            return;
        }

        container.setAttribute('style', 'margin: 0 -1.6rem');

        // Fade out the gradient as you approach the end of scroll
        const distanceToEnd = maxScrollLeft - scrollLeft;
        const opacity = Math.min(1, distanceToEnd / 50);
        gradientDiv.style.opacity = scrollLeft / maxScrollLeft < 0.7 ? '1' : opacity.toFixed(2);
    };

    scrollable.addEventListener('scroll', updateGradient);

    updateGradient();
}